// src/services/enrollmentService.js
import api, { BASE_URL } from './api';

class EnrollmentService {

  async getEnrollments(medicalCenterId, programId = null) {
    try {
      if (!medicalCenterId) throw new Error('Medical Center ID is required');
  
      let url = `${BASE_URL}/medical_centers/${medicalCenterId}/enrollments`;
      if (programId) {
        url += `?program_id=${programId}`;
      }
  
      const enrollments = await api.get(url);
  
      if (!Array.isArray(enrollments)) return [];
  
      return enrollments.map(e => ({ ...e, medical_center_id: medicalCenterId }));
    } catch (error) {
      console.error('Error fetching enrollments:', error);
      return [];
    }
  }

// Add this method to get a specific enrollment with full call session data
async getEnrollmentWithDetails(enrollmentId, medicalCenterId) {
    try {
      const response = await api.get(`${BASE_URL}/medical_centers/${medicalCenterId}/enrollments/${enrollmentId}`);
      return response;
    } catch (error) {
      console.error('Error fetching enrollment with details:', error);
      throw error;
    }
  }


async createEnrollment(enrollmentData, medicalCenterId = null, userRole = null) {
    if (userRole === 'admin') {
      if (!medicalCenterId) {
        throw new Error('Medical Center ID is required to create an enrollment');
      }
    } else {
      if (!medicalCenterId) {
        throw new Error('Medical Center ID is required for non-admin users');
      }
    }
    
    const payload = {
      enrollment: {
        patient_id: enrollmentData.patient_id,
        program_id: enrollmentData.program_id,
        start_date: enrollmentData.start_date,
        end_date: enrollmentData.end_date,
        call_rules: enrollmentData.call_rules,
        list_of_symptoms_to_ask: enrollmentData.list_of_symptoms_to_ask,
        device_id: enrollmentData.device_id || null
      }
    };
    
    
    return await api.post(`${BASE_URL}/medical_centers/${medicalCenterId}/enrollments`, payload);
  }

  // Update enrollment
  async updateEnrollment(enrollmentId, enrollmentData, medicalCenterId = null, userRole = null) {
    if (userRole === 'admin') {
      if (!medicalCenterId) {
        throw new Error('Medical Center ID is required to update an enrollment');
      }
    } else {
      if (!medicalCenterId) {
        throw new Error('Medical Center ID is required for non-admin users');
      }
    }
    
    const response = await api.put(
      `${BASE_URL}/medical_centers/${medicalCenterId}/enrollments/${enrollmentId}`,
      {
        enrollment: enrollmentData
      }
    );
    return response;
  }

  // Delete enrollment
  async deleteEnrollment(enrollmentId, medicalCenterId = null, userRole = null) {
    if (userRole === 'admin') {
      if (!medicalCenterId) {
        throw new Error('Medical Center ID is required to delete an enrollment');
      }
    } else {
      if (!medicalCenterId) {
        throw new Error('Medical Center ID is required for non-admin users');
      }
    }
    return await api.delete(`${BASE_URL}/medical_centers/${medicalCenterId}/enrollments/${enrollmentId}`);
  }

  // Calculate stats from enrollments data


  calculateStats(enrollments = []) {
    const totalEnrollments = enrollments.length;

    const activeEnrollments = enrollments.filter(
      (enrollment) => enrollment.status === 'active'
    ).length;

    // Treat completed as not active for the Inactive card
    const inactiveEnrollments = enrollments.filter((enrollment) =>
      ['inactive', 'completed'].includes(enrollment.status)
    ).length;

    const completionRate =
      totalEnrollments > 0
        ? Math.round((activeEnrollments / totalEnrollments) * 100)
        : 0;

    return {
      totalEnrollments,
      activeEnrollments,
      inactiveEnrollments,
      completionRate
    };
  }

}

export const enrollmentService = new EnrollmentService();